import {Component, ViewChild} from "@angular/core";
import * as moment from "moment";
import * as firebase from 'firebase/app';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NavParams, ToastController, ViewController, AlertController} from "ionic-angular";
import {Params} from "../params";

declare var google;

@Component({selector: 'page-customer', templateUrl: 'customer.html'})

export class CustomerPage {
  @ViewChild('inputAddress') inputAddress;
  title;
  plans;
  plans_obj;
  all_foods;
  foods;
  disc = Params.disc;
  max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  addForm: FormGroup;
  edit:boolean = false;
  autocomplete;
  nativeAutocomplete;
  coords;
  tab: string = "datos";
  place;
  cond = {};
  showcond : boolean = false;
  userDayPrize: number = 0;
  deliveries = {
    0 : 0,
    1 : 700,
    2 : 600,
    3 : 500,
    4 : 300,
    5 : 0,
    6 : 400,
    7 : 500,
    8 : 600
  }
  portions = {
    accompaniment: 150,
    principal: 180,
    unique: 330
  }
  day_price = 0;
  type_price = 'week';
  old_foods = {};
  totals = {
    total_foods: 0,
    total_discount:0,
    total_delivery:0,
    total_aditional:0,
    total_theory:0
  }
  money = Params.money;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController
  ) {
    console.log(this.totals)
    this.plans_obj = this.params.get("plans");
    let ref_plans = this.plans_obj;
    this.plans = [];
    for(let i=0;i<Object.keys(ref_plans).length;i++){
      let temp_plan = ref_plans[Object.keys(ref_plans)[i]];
      temp_plan.key = Object.keys(ref_plans)[i];
      this.plans.push(temp_plan);
    }

    this.all_foods = this.params.get("foods");
    this.old_foods = this.params.get("old_foods");
    console.log('all_foods', this.all_foods);
    console.log('old_foods', this.old_foods);
    this.foods = [];
    let default_days = [1,2,3,4,5];

    this.addForm = builder.group({
      'name': ['', Validators.required],
      'lastname': ['', Validators.required],
      'sexo': ['', Validators.required],
      'rut': [''],
      'email': ['', Validators.required],
      'address': ['', Validators.required],
      'address_info': [''],
      'phone': ['', Validators.required],
      'plan': ['', Validators.required],
      'foods': [[]],
      'restrictions': [''],
      'condition': [{}],
      'route': [''],
      'tall': [''],
      'birth': [''],
      'datestart': [moment().startOf('day').format(),Validators.required],
      'restriction_reason': [''],
      'active' : [true, Validators.required],
      'route_obs' : [''],
      'route_pos' : [''],
      'delivery' : ['7'],
      'discount' : [0],
      'aditional_cost' : [0],
      'aditional_cost_obs' : [''],
      'restricted_days' : [default_days],
    });

    this.title = "Nuevo Cliente";
    if(this.params.get("customer")){
      let customer = this.params.get("customer");
      customer["restricted_days"] = (customer["restricted_days"]) ? customer["restricted_days"] : default_days;
      this.edit = true;
      this.title = "Editar Cliente";

      this.addForm = builder.group({
        'name': [customer["name"], Validators.required],
        'lastname': [customer["lastname"], Validators.required],
        'sexo': [customer["sexo"], Validators.required],
        'rut': [customer["rut"]],
        'email': [customer["email"], Validators.required],
        'address': [customer["address"], Validators.required],
        'address_info': [customer["address_info"]],
        'phone': [customer["phone"], Validators.required],
        'plan': [customer["plan"], Validators.required],
        'foods': [customer["foods"], Validators.required],
        'restrictions': [customer["restrictions"]],
        'condition': [customer["condition"]],
        'route': [customer["route"]],
        'tall': [customer["tall"]],
        'birth': [customer["birth"]],
        'datestart': [customer["datestart"]],
        'restriction_reason': [customer["restriction_reason"]],
        'active' : [customer["active"]],
        'route_obs' : [customer["route_obs"]],
        'route_pos' : [customer["route_pos"]],
        'delivery' : [customer["delivery"] ? customer["delivery"] : '7'],
        'discount' : [customer["discount"] ? customer["discount"] : 0],
        'aditional_cost' : [customer["aditional_cost"]],
        'aditional_cost_obs' : [customer["aditional_cost_obs"]],
        'restricted_days' : [customer["restricted_days"]],
      })
      this.coords = customer["location"] ? customer["location"] : "";
      this.cond = customer["conditions"] ? customer["conditions"] : {};
      this.portions = customer["portions"];
      console.log('portions', this.portions)
      this.type_price = customer['price_list'] ? customer['price_list'] : 'week';
      console.log("edit",customer);
      // this.planChange(customer["plan"]);
      this.showcond = true;
      this.calculate_dayprice();
    }
  }

  ionViewDidLoad(){
    this.nativeAutocomplete = document.getElementById('autocomplete').getElementsByTagName('input')[0];
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.nativeAutocomplete),
      {types: ['geocode'],
        componentRestrictions: {country: "cl"}});

    this.autocomplete.addListener('place_changed', ()=>{
      this.place = this.autocomplete.getPlace();
      this.addForm.value.address = this.place.formatted_address;
      this.coords = {
        lat : this.place.geometry.location.lat(),
        lng : this.place.geometry.location.lng()
      }
    });
  }

  findFood(code, param){
    let name = 'n/a';
    if(param == 'price'){
      if(this.type_price == 'week'){
        const f = this.all_foods.filter((x) => x.value == code);
        if(f.length) name = f[0][param];
      }

      if(this.type_price == 'month'){
        const f = this.all_foods.filter((x) => x.value == code);
        if(f.length) name = this.disc(f[0][param],5).toString();
      }

      if(this.type_price == 'tri'){
        const f = this.all_foods.filter((x) => x.value == code);
        if(f.length) name = this.disc(f[0][param], 10).toString();
      }

      if(this.type_price == 'old'){
        name = this.old_foods[code].prize;
      }

    }else{
      const f = this.all_foods.filter((x) => x.value == code);
      if(f.length) name = f[0][param];
    }

    return name;
  }

  calculate_discount(){
    console.log(this.day_price);
  }

  addFood(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Nueva comida');

    for(let food of this.all_foods){
      alert.addInput({
        type: 'radio',
        label: food.name,
        value: food.value,
        disabled: this.disableFood(food)
      });
    }


    alert.addButton('Cancelar');
    alert.addButton({
      text: 'Agregar',
      handler: data => {
        this.addForm.value.foods.push(data);
      }
    });
    alert.present();
  }

  deleteFood(f){
    this.addForm.value.foods.splice(this.addForm.value.foods.indexOf(f),1);
  }

  disableFood(food){
    return !food.active && this.addForm.value.foods.indexOf(food.value) == -1
  }

  geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    }
  }

  foodChange(){
    this.showcond = true;
  }

  planChange(plan){
    this.refreshPortions();
    this.showcond = false;
    let _plan = plan;
    if(typeof _plan=="undefined") _plan = this.addForm.value.plan;
    /* let _foods = this.plans_obj[_plan].foods;
    let foods = [];
    for(let i=0;i<_foods.length;i++){
      if(this.all_foods[_foods[i]]){
        if(this.all_foods[_foods[i]].active){
          let food = {
            key : _foods[i],
            name : this.all_foods[_foods[i]].name
          }
          foods.push(food);
        }
      }
    }
    this.foods = foods; */
  }

  refreshPortions(){
    this.portions = {
      principal: 180,
      accompaniment: 150,
      unique: 330
    }

    if(this.addForm.value.sexo==="F"){
      this.portions = {
        principal: 150,
        accompaniment: 120,
        unique: 270
      }
    }
    if(this.addForm.value.plan==="B" || this.addForm.value.plan==="A"){
      this.portions = {
        principal: 200,
        accompaniment: 200,
        unique: 400
      }
    }

  }

  trunkDecimals(num){
    let val = '0';
    if(num){
      val = parseFloat(num).toFixed(2)
    }
    return val;
  }

  private cleanUndefined(cond){
    let r = {};
    let v = Object.keys(cond);
    for(let i=0;i<v.length;i++){
      if(cond[v[i]]!=undefined && cond[v[i]]!='') r[v[i]] = cond[v[i]];
    }
    return r;
  }

  ngAfterViewInit() {
    if(this.nativeAutocomplete) this.addForm.value.address = this.nativeAutocomplete.value;
  }

  tabDatos(){
    if(this.nativeAutocomplete.value) this.addForm.value.address = this.nativeAutocomplete.value;
  }

  changeDayValue(){
    this.addForm.value.discount = 100 - (Number(this.day_price)*100)/this.totals.total_theory;
    console.log(this.addForm.value.discount);
  }

  calculate_dayprice(){
    console.log('calculate_dayprice');
    let sum = 0
    this.addForm.value.foods.forEach((f) => {
      sum = sum + Number(this.findFood(f,'price'));
    });
    this.totals.total_foods = sum;
    this.totals.total_aditional = sum + Number(this.addForm.value.aditional_cost);
    this.totals.total_discount =  Number((((100 - Number(this.addForm.value.discount))/100) * sum).toFixed(0));
    this.totals.total_theory = this.totals.total_aditional + this.deliveries[this.addForm.value.delivery];
    this.day_price = this.totals.total_discount + this.deliveries[this.addForm.value.delivery] + Number(this.addForm.value.aditional_cost);
    console.log(this.day_price);
  }


  tabCobros(){
   // this.userDayPrize = this.dayPrize(this.addForm.value,this.all_foods,false);
  }

  save() {
    let data = this.addForm.value;
    data.email = data.email.toLowerCase();
    let code = Params.md5(data.email);
    data.location = this.coords;
    data.address = this.nativeAutocomplete.value;
    data.conditions = this.cleanUndefined(this.cond);
    data.portions = this.portions;
    this.calculate_dayprice();
    data.day_price = this.day_price;
    data.price_list = this.type_price;
    data.datestart = moment(data.datestart).startOf('day').format();
    let msg = 'Cliente '+data.name+' creado exitosamente';
    if(this.edit) {
      msg = 'Cliente '+data.name+' editado exitosamente';
      this.params.get("customer")["active"] = data.active;
      firebase.database().ref('customers/'+code).set(data).then(_ => {
        let toast = this.toastCtrl.create({
          message: msg,
          duration: 3000
        });
        toast.present();
      });
      this.viewCtrl.dismiss();
      console.log(code)
    }else{
      firebase.database().ref('customers/'+code).once('value')
        .then((snap)=> {
          if (snap.exists()) {
            let toast = this.toastCtrl.create({
              message: 'Este email ya está siendo utilizado. Utilice otro.',
              duration: 5000
            });
            toast.present();
          }else{

            // firebase.functions().httpsCallable('acContact')(data)
            //   .then((res) => {
            //     console.log('res acContact', res);
            //   }).catch((err) => {
            //     console.log('catch err acContact', err);
            //   });

            firebase.database().ref('customers/'+code).set(data).then(_ => {
              let toast = this.toastCtrl.create({
                message: msg,
                duration: 3000
              });
              toast.present();
            });
            this.viewCtrl.dismiss();
          }
        })
    }



  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/customer.ts